import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, finalize } from 'rxjs';

export interface LoaderState {
  show: boolean;
}


@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaderSubject = new Subject<LoaderState>();
  loaderState = this.loaderSubject.asObservable();

  constructor() { }

  show() {
    this.loaderSubject.next(<LoaderState>{ show: true });
  }

  hide() {
    this.loaderSubject.next(<LoaderState>{ show: false });
  }
}

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {

  requests: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  requests$ = this.requests.asObservable();


  constructor(private loaderService: LoaderService) { }

  totalRequests = 0;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.totalRequests++;
    this.requests.next(this.totalRequests);
    if (req.url.indexOf('advert') === -1) {
      this.showLoader();
    }
    return next.handle(req)
      .pipe(
        finalize(() => {
          // request completes, errors, or is cancelled
          this.onEnd();
        })
      );
  }


  onEnd(): void {
    this.totalRequests--;
    this.requests.next(this.totalRequests);
    this.hideLoader();
  }

  showLoader(): void {
    this.loaderService.show();
  }

  hideLoader(): void {
    if (this.totalRequests === 0)
      this.loaderService.hide();
  }

}
